import { PrefixWithLocale } from '../../../Utilities';

const SAMPLES_URL = '/roofing/order-samples';

const orderSamplesUrl = localeCode => PrefixWithLocale(SAMPLES_URL, localeCode);

export default orderSamplesUrl;
